<template>
  <div class="mb-4">

    <!--#region -- Content ---->
    <!--#region SFDC Synchronization Real Data-->

    <div class="caption-label-hide d-flex">
      <div v-if="sfdcReportData">
        <h3>Salesforce Report - {{reportName}}</h3>
      </div>
    </div>
    <div>
      <b-alert v-if="sfdcReportRecordCount !== null && sfdcReportRecordCount > 3500" show
               variant="warning">
        {{reachMaxRecordHint}}
      </b-alert>
    </div>
    <div v-if="sfdcReportData && sfdcReportRecordCount != null" class="caption-label-hide d-flex">
      <b-badge style="margin-right: 10px;"
               variant="primary">{{sfdcReportRecordCount}}</b-badge>
      <button v-if="sfdcReportData && actionEnable"
              type="button"
              class="btn btn-sm btn-link p-0 btn-svg gtc-icon-download"
              v-b-tooltip.hover.right title="Download Report"
              @click="downloadSalesforceReport(reportId, reportName)">
      </button>
    </div>
    <div v-else class="caption-label-hide d-flex">
      <b-badge style="margin-right: 10px;" variant="primary">0</b-badge>
    </div>


    <div class="table-container" style="padding-top: 10px;" v-if="sfdcReportData && sfdcReportFields && actionEnable">
      <b-table :fields="sfdcReportFields" :items="sfdcReportData"
               small
               thead-class="thead-light text-dark"
               :busy="searchingSFDC"
               style="width: calc(100% - 10px)">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
    </div>


    <!--#endregion-->
    <!-- #endregion Modal-->
  </div>
</template>

<script>
  export default {
    name: 'sfdc-prd-line-view-only',
    props: {
      prop_sfdc_page_obj: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },

    },
    data: function () {
      return {
        isRouterAlive: true,
        reportId: encodeURIComponent(this.$route.params.report_id),
        reportName: null,
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        sfdcReportData: null,
        sfdcReportRecordCount: null,
        fixModel: true,
        fixCustomizationPn: "Customization",
        basicInfo: null,
        loginUser: null,
        userSites: null,
        userFunctions: null,
        userRoles: null,
        login_user_name: null,
        actionEnable: false,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        createBy: null,
        reachMaxRecordHint: 'Report data exceeds display limit. For your preview, we are showing the first 3500 rows. Click below "Download" button to view the complete dataset.',
        sfdcReportFields: null,
        selectedMpsIdToSync: [],
        reloadBusy: false,
      }
    },
    /*
    computed: {
      userFunctions() {
        return this.$session.get('user_functions');
      },
      userRoles() {
        return this.$session.get('user_roles');
      },

    },
    */
    created() {
      let self = this;
      self.checkLoggedIn();
      self.actionEnable = self.saSearchEnabled(); // self.checkActionEnable();
      if (self.actionEnable) {
        self.getSalesforceReport();
      } else {
        this.$message.error(`You do not have permissions to access Salesforce Report.\nPlease contact FTIE system administrators.`);
      }
      self.reportDefaultName = '';
      // console.log("SFDC Copo actionEnable:");
      // console.log(self.actionEnable);
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_name = this.$session.get('user_name');
        //var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');
        this.login_user_name = user_name
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
      },

      getSalesforceReport() {
        let self = this;
        let resultText = null;
        let reportName = null;
        let columnList = null;
        let url = self.$root.baseUrl + '/salesforce-py/report/page/report-id/' + self.reportId;
        let request_data = {
          report_id: self.reportId,
          user_name: self.login_user_name,
          user_roles: self.userRoles,
          user_functions: self.userFunctions,
          user_site: self.userSites,
        };
        self.searchingSFDC = true;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);
            if (response.status === 200) {
              resultText = res['report_result'];
              columnList = res['report_columns'];
              reportName = res['report_name'];
              try {
                self.sfdcReportRecordCount = res['records_count'];
              } catch (error) {
                self.sfdcReportRecordCount = 0;
                onsole.log("res['report_result'].length::");
                console.log(res['report_result'].length);
              }
            }
            else {
              // self.$message.exception('Internal Server Error!');
              resultText = null;
              self.sfdcReportRecordCount = 0;
            }
          }, (error) => {
            console.log(error);
            self.sfdcReportRecordCount = 0;
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searchingSFDC = false;
            eventHub.$emit('loading', false);
            if (resultText !== null) {
              self.sfdcReportData = resultText;//JSON.parse(resultText);
              self.reportName = reportName;
            }
            if (columnList !== null) {
              var reportCols = new Array();
              for (let i = 0; i < columnList.length; i++) {
                reportCols.push({
                  key: columnList[i],
                  label: columnList[i],
                  thClass: 'align-middle',
                  sortable: true
                })
              }
              self.sfdcReportFields = reportCols;
            }
            console.log("self.reportName::");
            console.log(self.reportName);

            
            //self.$refs['salesforceReportModal'].show();
          })
      },
      downloadSalesforceReport(reportId, reportName) {
        let self = this;
        let reportNameDisplayOnFile = '';
        if (reportName !== null) {
          reportNameDisplayOnFile = reportName;
        }
        let purpose = 'FTIE_Salesforce_Report_' + reportNameDisplayOnFile;
        let url = self.$root.baseUrl + '/salesforce-py/report/download/report-id/' + reportId;
        console.log("purpose" + purpose);
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();

        let request_data = {
          downloadTime: downloadTime,
          //download_purpose: purpose,
          report_id: reportId,
          report_name: reportNameDisplayOnFile,
          user_name: self.login_user_name,
          user_roles: self.userRoles,
          user_functions: self.userFunctions,
          user_site: self.userSites,
        };

        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = purpose + '_' + dateTimeStr + '.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },

      saSearchEnabled() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        if ((self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 && self.userSites && _.indexOf(self.userSites, 'Getac') > -1)) || (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1))
        ) {
          console.log("Search Enabled!!");
          return true
        }
        if (((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1) && self.userRoles && (_.indexOf(self.userRoles, 'GRO_SA_Leader') > -1 || _.indexOf(self.userRoles, 'GRO_SA') > -1))) {
          console.log("Search Enabled!!");
          return true
        }
        console.log("Search Disabled!!");
        return false;
      },

      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        if (self.loginUser === 'power') {
          return true;
        }

        // loginUser is gtc owner
        if (self.loginUser !== null && self.createBy !== null && self.loginUser === self.createBy) {
          return true;
        }
        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1 || _.indexOf(self.userRoles, 'ES_PM') > -1) {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
            return true;
          }
        }
        //login_user_name === ftie_page_obj.gtc_owner || login_user_name === 'power' || (userRoles !== null && userRoles.includes('Admin')))
        return false;
      },

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework-sfdc/SfdcReportDisplay.vue